export const data = [
	{
		title: 'Marci Wiersma',
		description: '"Digitech is a much-needed blessing and exceeded our expectations in every way. They are honest, straightforward, they take care of ALL your needs quickly, they are reliable, you can count on them and most of all, they do everything they say they will do, no BS."',
		image: './assets/clients2.jpg',
	},
	{
		title: 'Dana Williams',
		description: '"Digitech is a highly professional team, and we are satisfied with our long-term partnership with them. They’re an extremely knowledgeable agency in everything SEO-related. It’s rare for us to work with a service provider for so long, but it’s just that everything’s been great."',
		image: './assets/man1.jpg',
	},
	{
		title: 'Whitney Wells Lewis',
		description: '"These guys are incredible. They have helped us to grow our business and now the biggest problem we seem to come across is having too much business - which is the ideal problem to have. We are right where we wanted to be and Thrive made that possible. Thanks guys!"',
		image: './assets/security2.jpg',
	},
	{
		title: 'Chad Montgomery',
		description: '"Working with the Digitech team has been a most pleasant experience! Their dedication and passion for what they do is exemplified by their unrivaled customer support and attentiveness to the specific needs of our business. We look forward to a long-lasting and prosperous relationship!"',
		image: './assets/teamwork2.jpg',
	},

	{
		title: 'Will Gatner',
		description: 'Thanks to Digitech’s efforts, we have achieved up to 60% organic traffic increase and 32% revenue increase despite the pandemic. The team is very organized, informative, and timely, and their SEO expertise is impressive. They stay updated and test new strategies to get fast results.',
		image: './assets/man2.jpg',
	},
];

export const sliderSettings = {
	arrows: false,
	slidesToShow: 3,
	focusOnselect: false,
	accessability: false,
	responsive: [
		{
			breakpoint: 1280,
			settings: {
				slidesToShow: 2,
			},
		},

		{
			breakpoint: 900,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};
